var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"el-container--fullscreen",staticStyle:{"background-color":"#00204d"},attrs:{"direction":"vertical"}},[_c('base-center',{attrs:{"span":8,"xs":18,"sm":14,"md":10,"lg":8}},[_c('el-header',{attrs:{"bordered":false,"color":"nav-primary"}},[(_vm.$slots.title)?[_vm._t("title")]:_c('span',{class:{
          'mb-32': true,
          'el-text': true,
          'el-text--display-medium': true,
          'el-text--ellipsis': true,
          'el-text--color-fixed-white': _vm.invert,
        }},[_vm._v(" "+_vm._s(_vm.title)+" ")])],2),_c('base-card',{staticStyle:{"max-width":"672px","min-width":"432px"},attrs:{"alert":_vm.alert}},[(_vm.$slots.header)?_c('base-card-item',{attrs:{"slot":"header"},slot:"header"},[_vm._t("header")],2):_vm._e(),_c('base-card-item',[_vm._t("default")],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }